import { useQueryClient } from "@tanstack/react-query";

import orderCore from "../../core/order.core";
import { useTranslation } from "../../core/translation.core";
import { Order } from "../../types/order";
import UpdateBadge from "../form/updateBadge.comp";
import DocumentCheckIcon from "../../icons/documentCheck.icon";

export default function PaymentStatusEditor({ order }: { order: Order }) {
  const { t, msg } = useTranslation();
  const queryClient = useQueryClient();

  if (!order) return null;

  const payment = order.activePaymentSession;

  if (!payment) return null;

  const options = [
    { value: "awaiting", label: t(msg.payment.awaiting), css: "text-white bg-orange-700" },
    { value: "deposit", label: t(msg.payment.deposit), css: "text-white bg-blue-700" },
    { value: "partialPayment", label: t(msg.payment.partialPayment), css: "text-white bg-purple-700" },
    { value: "paid", label: t(msg.payment.paid), css: "text-white bg-yellow-700" },
    { value: "refunded", label: t(msg.payment.refunded), css: "text-white bg-green-700" },
  ];

  async function updateStatus(status: string) {
    await orderCore.updateOrder({
      orderId: order.id,
      data: {
        paymentStatus: status,
      },
      queryClient,
    });
  }

  return (
    <div data-order-payment-status={order.paymentStatus}>
      <UpdateBadge currentValue={payment.paymentStatus} options={options} onUpdate={updateStatus} />
      {order.paymentProof && <DocumentCheckIcon className="w-6 h-6 text-green-400" />}
    </div>
  );
}
